import CollapsibleSection from 'components/CollapsibleSection';
import Metadata from 'components/Metadata';
import formatDuration from 'helpers/formatDuration';
import { useTranslation } from 'react-i18next';
import Submission from 'types/Submission';

interface Props {
  submission: Submission;
}

export default function SubmissionSidebarMetadata(props: Props) {
  const { submission } = props;
  const { t } = useTranslation();

  return (
    <CollapsibleSection
      title={t('ugcRequestShow.submissions.sidebar.metadata')}
    >
      <div className="mb-2">
        <Metadata title={t('ugcRequestShow.submissions.sidebar.dimensions')}>
          {submission.width}x{submission.height}
        </Metadata>
      </div>

      {!!submission.videoDuration && (
        <Metadata title={t('ugcRequestShow.submissions.sidebar.duration')}>
          {formatDuration(submission.videoDuration)}
        </Metadata>
      )}

      <Metadata title={t('ugcRequestShow.submissions.sidebar.contentType')}>
        {submission.contentType}
      </Metadata>
    </CollapsibleSection>
  );
}
